import { log } from "@/utils/useLogger";
import { startAppListening } from "..";
import { canvasDownloadedAsImage } from "@/store/actions";
import { getBaseLayerBlob } from "@/utils/getBaseLayerBlob";
import { downloadBlob } from "@/utils/utils";
import { addToast } from "@/reducer/designslice";

const moduleLog = log.child({ namespace: "canvasSavedToGalleryListener" });

export const addCanvasDownloadedAsImageListener = () => {
  startAppListening({
    actionCreator: canvasDownloadedAsImage,
    effect: async (action, { dispatch, getState }) => {
      const state = getState();
      const blob = await getBaseLayerBlob(state);
      if (!blob) {
        moduleLog.error("获取基础层blob时出现问题");
        dispatch(
          addToast({
            title: "下载图片时出现问题",
            description: "无法导出绘图层",
            status: "error",
          })
        );
        return;
      }

      downloadBlob(blob, "canvas.png");
      dispatch(addToast({ title: "图片下载", status: "success" }));
    },
  });
};
